import { unstable_createMuiStrictModeTheme, colors } from "@material-ui/core";

import palette from "./palette";

// TODO: switch back to createMuiTheme when we upgrade to 5:
// https://github.com/mui-org/material-ui/issues/13394#issuecomment-619266831
export default unstable_createMuiStrictModeTheme({
  palette: {
    background: {
      default: "#FFFFFF",
      paper: colors.common.white
    },
    primary: {
      main: palette.navy
    },
    text: {
      primary: palette.navy,
      secondary: palette.darkGray
    },
    error: {
      main: palette.red
    }
  },
  typography: {
    fontFamily: "Poppins" // TODO: fallback fonts
  },
  overrides: {
    MuiButton: {
      contained: {
        backgroundColor: palette.lightGray,
        "&:hover": {
          backgroundColor: palette.midGray
        },
        "&:disabled": {
          backgroundColor: palette.lightGray
        }
      }
    },
    MuiCardHeader: {
      root: {
        backgroundColor: palette.lightGray
      },
      title: {
        // TODO: use typography, this currently uses the h5 variant but we want
        // body1 (or to override h5) fix subtitle etc...
        fontSize: 16
      }
    },
    MuiInput: {
      input: {
        "&::placeholder": {
          color: palette.darkGray,
          opacity: 1
        }
      },
      root: {
        fontSize: "inherit"
      }
    },
    MuiFormLabel: {
      root: {
        fontSize: "inherit"
      }
    },
    MuiStepLabel: {
      label: {
        color: palette.navy,
        "&.MuiStepLabel-active": {
          color: palette.darkBlue
        }
      }
    },
    MuiStepConnector: {
      lineVertical: {
        borderColor: palette.navy
      }
    },
    MuiStepIcon: {
      root: {
        color: palette.navy,
        "&.MuiStepIcon-active": {
          color: palette.darkBlue
        }
      }
    },
    MUIDataTableHeadCell: {
      data: {
        "font-weight": 999,
        textAlign: "left"
      },
      root: {
        padding: "4px"
      }
    },
    MUIDataTableBodyCell: {
      root: {
        padding: "4px"
      }
    },
    MuiTableCell: {
      head: {
        "font-weight": 999
      }
    },
    MuiTableRow: {
      root: {
        "&$selected": {
          backgroundColor: "#F0EEF5"
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        color: palette.navy,
        "&$checked": {
          color: palette.navy
        }
      }
    },
    MuiRadio: {
      colorSecondary: {
        color: palette.navy,
        "&$checked": {
          color: palette.navy
        }
      }
    }
  }
});
